export default "__VITE_ASSET__DJlLlW7___"